/** @jsxImportSource @emotion/react */
import React from "react";
import { BLOCK_EXPLORER_URL_BY_NETWORK } from "../../../../config/consts";
import { ReactComponent as CheckIcon } from "../../../../img/approval_svgs/Check.svg";
import { ReactComponent as ViewTransactionIcon } from "../../../../img/trade-interface/view_transaction_white.svg";
import { GlobalStore } from "../../../../store/global/GlobalStore";
import { Text } from "../../../general/Text";

export const Approved: React.FC<{ tx: string; isVisible: boolean }> = ({ isVisible, tx }) => {
  const network = GlobalStore.useState(s => s.network);
  const theme = GlobalStore.useState(s => s.theme);
  if (!isVisible) {
    return null;
  }
  return (
    <div style={{ display: "flex", alignItems: "center", justifyContent: "end" }}>
      <CheckIcon />
      <Text textStyle="Paragraph" size="Large" color={theme["Colour ramps"].Green["400"]}>
        Approved
      </Text>
      <a
        className="approval-many-btn text-white"
        href={`${BLOCK_EXPLORER_URL_BY_NETWORK[network.id]}tx/${tx}`}
        target="_blank"
        rel="noreferrer"
        style={{ marginLeft: "10px" }}
      >
        <ViewTransactionIcon style={{ width: "18px", height: "18px" }} />
        <Text textStyle="Paragraph" size="Large">
          View Transaction
        </Text>
      </a>
    </div>
  );
};
